<template>
  <div id="register-page">
    <a-breadcrumb>
      <a-breadcrumb-item><router-link to="/">Home</router-link></a-breadcrumb-item>
      <a-breadcrumb-item>Register</a-breadcrumb-item>
    </a-breadcrumb>
    <a-divider><h2>Register</h2></a-divider>
    <a-form
    id="register-form"
    :form="regForm"
    class="register-form"
    @submit="handleSubmit"
    >
    <a-alert v-if="errorMessage.length > 0" type="error" :message="userErrorMessages" banner />
    <a-alert
      v-if="successRegistration"
      type="success"
      message="Registration successful! Re-directing..."
      banner/>
      <br />
    <a-form-item
    v-bind="formItemLayout"
    label="Email Address">
      <a-input
        v-decorator="[
          'email',
          {
            rules:
            [{
              required: true, message: 'Please enter your valid Email Address',
            },
            {
              type: 'email', message: 'Please enter your valid Email Address'
            }]
          }
        ]"
        placeholder="Email Address"
        type="email"
      >
      </a-input>
    </a-form-item>
    <a-form-item
      v-bind="formItemLayout"
      label="Password"
    >
      <a-input
        v-decorator="[
          'password',
          {
            rules: [{
              required: true, message: 'Please input your password!',
            }, {
              validator: validateToNextPassword,
            }],
          }
        ]"
        type="password"
      />
    </a-form-item>
    <a-form-item
      v-bind="formItemLayout"
      label="Confirm Password"
    >
      <a-input
        v-decorator="[
          'confirm',
          {
            rules: [{
              required: true, message: 'Please confirm your password!',
            }, {
              validator: compareToFirstPassword,
            }],
          }
        ]"
        type="password"
        @blur="handleConfirmBlur"
      />
    </a-form-item>
    <a-form-item
    v-bind="tailFormItemLayout"
    >
      <a-button
        type="primary"
        html-type="submit"
        class="login-form-button"
      >
        Register
      </a-button>
      Or <router-link to="/login">
        Login now!
      </router-link>
    </a-form-item>
  </a-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'register',
  data() {
    return {
      errorMessage: '',
      successRegistration: false,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 16 },
          sm: { span: 8 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 8,
            offset: 8,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('common', {
      userErrorMessages: 'commonErrors',
    }),
  },
  beforeCreate() {
    this.regForm = this.$form.createForm(this);
  },
  methods: {
    ...mapActions('user', {
      registerUser: 'registerUser',
    }),
    handleSubmit(e) {
      e.preventDefault();
      this.regForm.validateFields((err, values) => {
        if (!err) {
          this.$recaptcha('register').then(() => {
            this.registerUser(values);
          });
        }
      });
    },
    handleConfirmBlur(e) {
      // eslint-disable-next-line prefer-destructuring
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.regForm;
      if (value && value !== form.getFieldValue('password')) {
        callback('Please re-enter your password.');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.regForm;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case 'user/LOGERROR':
          this.errorMessage = this.userErrorMessages;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          break;
        case 'user/USERREGISTRATION':
          this.successRegistration = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(() => {
            // eslint-disable-next-line no-unused-vars
            this.$router.replace({ path: 'thank-you' }).catch((err) => {});
          }, 1000);
          break;
        default:
          // this.successRegistration = false;
      }
    });
  },
};
</script>
<style scoped lang="css">
.login-form-button {
  width: 100%;
}
</style>
